"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MetadataSimilarProductDTO_1 = require("../../report/model/MetadataSimilarProductDTO");

var MetadataSimilarProductDTOConverter_1 = require("./MetadataSimilarProductDTOConverter");

var MetadataSimilarProductDTOConverterImpl =
/*#__PURE__*/
function (_MetadataSimilarProdu) {
  _inherits(MetadataSimilarProductDTOConverterImpl, _MetadataSimilarProdu);

  function MetadataSimilarProductDTOConverterImpl() {
    _classCallCheck(this, MetadataSimilarProductDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(MetadataSimilarProductDTOConverterImpl).apply(this, arguments));
  }

  _createClass(MetadataSimilarProductDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new MetadataSimilarProductDTO_1.MetadataSimilarProductDTO(MetadataSimilarProductDTO_1.MetadataSimilarProductDTO.schema.siteExternalId.valueOfField(source), MetadataSimilarProductDTO_1.MetadataSimilarProductDTO.schema.siteName.valueOfField(source), MetadataSimilarProductDTO_1.MetadataSimilarProductDTO.schema.predecessorActive.valueOfField(source), MetadataSimilarProductDTO_1.MetadataSimilarProductDTO.schema.predecessorProductExternalId.valueOfField(source), MetadataSimilarProductDTO_1.MetadataSimilarProductDTO.schema.predecessorProductName.valueOfField(source), MetadataSimilarProductDTO_1.MetadataSimilarProductDTO.schema.successorActive.valueOfField(source), MetadataSimilarProductDTO_1.MetadataSimilarProductDTO.schema.successorProductExternalId.valueOfField(source), MetadataSimilarProductDTO_1.MetadataSimilarProductDTO.schema.successorProductName.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        siteExternalId: source.siteExternalId,
        siteName: source.siteName,
        predecessorActive: source.predecessorActive,
        predecessorProductExternalId: source.predecessorProductExternalId,
        predecessorProductName: source.predecessorProductName,
        successorActive: source.successorActive,
        successorProductExternalId: source.successorProductExternalId,
        successorProductName: source.successorProductName
      });
      return result;
    }
  }]);

  return MetadataSimilarProductDTOConverterImpl;
}(MetadataSimilarProductDTOConverter_1.MetadataSimilarProductDTOConverter);

exports.MetadataSimilarProductDTOConverterImpl = MetadataSimilarProductDTOConverterImpl;